import React, { useState, useMemo, useEffect } from "react";
import "./index.css";
import CircularProgress from "./components/circularProgress";
import ProgressBar from "./components/progressBar";
import { formatNaira } from "../../../../formatNaira";
import FactoryWeight from "./components/chart";
import stat from "../../../../assets/images/stat.png";
import axios from "axios";
import { switchEndpoint } from "../../../../redux/actions/endpoints";
import calendar from "../../../../assets/images/calendar.png";
import { toast } from "react-toastify";
import { storage } from "../../../../scopedStorage";

const FactoryMain = () => {
  const [stats, setStats] = useState({});
  const [stats2, setStats2] = useState({});
  const [charts, setCharts] = useState([]);
  const [charts2, setCharts2] = useState([]);
  const [valueA, setValueA] = useState(0.0);
  const [valueB, setValueB] = useState(0.0);

  const monthMap = {
    Jan: "January",
    Feb: "February",
    Mar: "March",
    Apr: "April",
    May: "May",
    Jun: "June",
    Jul: "July",
    Aug: "August",
    Sep: "September",
    Oct: "October",
    Nov: "November",
    Dec: "December",
  };

  const getChart = () => {
    const token = storage.getItem("token");
    axios
      .get(`${switchEndpoint}/factory/charts`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        const result1 = response.data.processed_requests;
        const result2 = response.data.unprocessed_requests;
        const formatted1 = Object.entries(result1).map(([key, val]) => ({
          month: monthMap[key],
          weight: val,
        }));
        const formatted2 = Object.entries(result2).map(([key, val]) => ({
          month: monthMap[key],
          weight: val,
        }));
        setCharts(formatted1);
        setCharts2(formatted2);
        // console.log(response.data);
      })
      .catch((error) => {
        console.log(error);
        toast.error(error.response.data.message, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          pauseOnHover: true,
          progress: undefined,
          theme: "light",
        });
      });
  };

  const getStat = () => {
    const token = storage.getItem("token");
    axios
      .get(`${switchEndpoint}/factory/statistics`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        setStats(response.data);
        // console.log(response.data);
      })
      .catch((error) => {
        console.log(error.response.data);
        toast.error(error.response.data.message, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          pauseOnHover: true,
          progress: undefined,
          theme: "light",
        });
      });
  };

  const getStat2 = () => {
    const token = storage.getItem("token");
    const today = new Date();
    const startDate = new Date(today.getFullYear(), today.getMonth(), 1);
    const formatDate = (date) => {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    };

    const start_date = formatDate(startDate);
    const end_date = formatDate(today);

    axios
      .get(`${switchEndpoint}/factory/statistics`, {
        headers: { Authorization: `Bearer ${token}` },
        params: {
          start_date: start_date,
          end_date: end_date,
        },
      })
      .then((response) => {
        setStats2(response.data);
      })
      .catch((error) => {
        toast.error(error.response.data.message, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          pauseOnHover: true,
          progress: undefined,
          theme: "light",
        });
      });
  };

  const evacuated = stats?.total_processed_counts || 0;
  const total = stats?.total_requests_count || 0;
  const percent = useMemo(
    () => Math.round((evacuated || 0 / total || 0) * 100),
    []
  );

  const size = 200; // SVG size
  const stroke = 14;
  const radius = (size - stroke) / 2;
  const circumference = 2 * Math.PI * radius;
  const offset = circumference - (percent / 100) * circumference;
  // One bar per product the evacuations were actually raised against. The old
  // version hardcoded Nylon and PET Plastics from the legacy roll-up, which
  // cannot name a product and reads zero for CAN and Aluminum — a truck of cans
  // simply did not appear on this chart.
  const productRows = stats?.products?.items || [];
  const unclassified = Number(stats?.products?.unclassified_tonnes) || 0;

  const captured = [
    ...productRows.map((p) => ({
      charity_name: p.name,
      total_donations: Number(p.requested_tonnes) || 0,
    })),
    ...(unclassified > 0
      ? [{ charity_name: "Not by product", total_donations: unclassified }]
      : []),
  ].filter((row) => row.total_donations > 0);

  // Fall back to the legacy pair only when nothing carries a product yet.
  const fallback = [
    { charity_name: "Nylon", total_donations: stats?.total_nylon_requests_count || 0 },
    { charity_name: "PET Plastics", total_donations: stats?.total_pet_plastic_requests_count || 0 },
  ];

  const rows = captured.length ? captured : fallback;
  const widest = Math.max(...rows.map((r) => r.total_donations), 0);

  // Bar width is a share of the largest row, so every product stays readable
  // next to a much bigger one instead of the two being divided by each other.
  const charityDonationsData = rows.map((row) => ({
    ...row,
    percentage: widest > 0 ? (row.total_donations / widest) * 100 : 0,
  }));

  const downloadReport = () => {
    const link = `${switchEndpoint}/factory/export-evacuation-requests`;
    window.open(link, '_blank');
  };

  useEffect(() => {
    getChart();
    getStat();
    getStat2();
  }, []);

  return (
    <main>
      <div className="main__container pb-5">
        <div className="FactoryDivs">
          <div
            style={{
              backgroundColor: "#fff",
              borderRadius: "12px",
              boxShadow: "0 2px 8px rgba(0, 0, 0, 0.006)",
              padding: "24px",
              width: "360px",
              textAlign: "center",
            }}
          >
            <h3
              style={{
                fontSize: "14px",
                fontWeight: "600",
                color: "#111",
                marginBottom: "20px",
                textAlign: "left",
              }}
            >
              Evacuation Percentage
            </h3>

            <div
              style={{
                position: "relative",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                margin: "30px 0",
              }}
            >
              <svg
                width={size}
                height={size}
                style={{
                  transform: "rotate(-90deg)",
                }}
              >
                <circle
                  style={{
                    fill: "none",
                    stroke: "#f7f8d7",
                    strokeWidth: stroke,
                  }}
                  cx={size / 2}
                  cy={size / 2}
                  r={radius}
                />
                <circle
                  style={{
                    fill: "none",
                    stroke: "#C8D92D",
                    strokeWidth: stroke,
                    strokeLinecap: "round",
                    strokeDasharray: circumference,
                    strokeDashoffset: offset,
                    transition: "stroke-dashoffset 0.6s ease",
                  }}
                  cx={size / 2}
                  cy={size / 2}
                  r={radius}
                />
              </svg>

              <div
                style={{
                  position: "absolute",
                  width: "150px",
                  height: "150px",
                  borderRadius: "50%",
                  backgroundColor: "#C8D92D",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: "#111",
                  fontWeight: "400",
                  fontSize: "18px",
                }}
              >
                {percent}%
              </div>
            </div>

            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "10px",
                fontSize: "14px",
                color: "#222",
                marginTop: "8px",
              }}
            >
              <div
                style={{
                  width: "40px",
                  height: "3px",
                  backgroundColor: "#C8D92D",
                  borderRadius: "2px",
                }}
              ></div>
              <span>
                {evacuated} of {total} Tonnes Evacuated
              </span>
            </div>

            <button
              style={{
                marginTop: "20px",
                width: "70%",
                padding: "12px",
                backgroundColor: "#C8D92D",
                color: "#111",
                border: "none",
                borderRadius: "6px",
                fontWeight: "600",
                fontSize: "14px",
                cursor: "pointer",
                transition: "background-color 0.2s ease",
                outline: "none",
                boxShadow: "none",
              }}
              onClick={() => {downloadReport()}}
              onMouseOver={(e) => (e.target.style.backgroundColor = "#b8c92a")}
              onMouseOut={(e) => (e.target.style.backgroundColor = "#C8D92D")}
              onFocus={(e) => {
                e.target.style.outline = "none";
                e.target.style.boxShadow = "none";
              }}
            >
            Download Report
            </button>
          </div>

          <div className="factoryRequest">
            <FactoryWeight
              stat={stat}
              valueA={valueA}
              valueB={valueB}
              charts={charts}
              charts2={charts2}
              stats2={stats2}
            />
          </div>
        </div>

        <div className="mt-5">
          <div className="d-flex justify-content-between align-items-center">
            <p
              className="mb-0 ml-2"
              style={{
                fontSize: "13px",
                fontWeight: "600",
                color: "#000",
              }}
            >
              Evacuation Weight Captured
            </p>
            <div className="d-flex">
              <div>
                <img src={calendar} alt={calendar} />
              </div>
              <p
                className="mb-0 ml-3"
                style={{
                  fontSize: "12px",
                  fontWeight: "400",
                  color: "#000",
                }}
              >
                This Month
              </p>
            </div>
          </div>
          <div>
            <hr />
          </div>

          <div>
            {charityDonationsData.map((charity) => {
              return (
                <div className="d-flex justify-content-center align-items-center mb-3">
                  <div>
                    <div className="d-flex align-items-center justify-content-center">
                      <p className="mb-0"> {charity.charity_name}</p>
                      <div
                        style={{
                          width: "50vw",
                          paddingLeft: "1rem",
                          paddingRight: "1rem",
                        }}
                      >
                        <ProgressBar
                          progress={parseInt(charity.percentage)}
                          fillerColor={"#000"}
                          backgroundColor="#FAFFCC"
                        />
                      </div>
                      <p className="mb-0">
                        {`${charity.total_donations} tonnes`}
                      </p>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </main>
  );
};

export default FactoryMain;
